<template>
	<div id="page-wrapper">
		<div class="row page-titles">
			<div class="col-md-5 align-self-center">
				<h3 class="text-themecolor">{{ $t('dashboard.weekly-review.title') }}</h3>
			</div>
			<div class="col-md-7 align-self-center">
				<ol class="breadcrumb">
					<li class="breadcrumb-item"><a href="javascript:void(0)">{{ $t('nav.home') }}</a></li>
					<li class="breadcrumb-item active">{{ $t('dashboard.weekly-review.title') }}</li>
				</ol>
			</div>
		</div>
		<div class="container-fluid">
			<!-- /row -->
			<div class="row">
				<div class="col-md-12 col-sm-12">
					<div class="card">
						<div class="card-header">
							<div class="pull-right">
								<div>
								  <el-date-picker
							      v-model="dateRange"
							      type="daterange"
							      value-format="yyyy-MM-dd"
							      ref="dateRange">
							    </el-date-picker>
							  </div>
							</div>
							<h5 class="mb-0">
								<el-tooltip :content="$t('dashboard.refresh')" placement="top">
									<el-button type="text" class="el-icon-refresh" @click="refreshData"></el-button>
								</el-tooltip>
							</h5>
						</div>
						<div class="card-body">
							<h3>{{ $t('dashboard.weekly-review.performance') }} 
								<el-tooltip :content="$t('salary.export')" placement="top">
									<el-button type="text" class="el-icon-download" @click="exportExcel('performance-report', 'Performance')"></el-button>
								</el-tooltip></h3>
							<el-table
							    id="performance-report"
							    :data="data.performance"
							    style="width: 100%"
							    height="500"
							    :default-sort = "{prop: 'team', order: 'ascending'}"
							    
							    :summary-method="getSummaries"
				    			:show-summary="false">
								<el-table-column
							      fixed
							      prop="name"
							      :label="$t('dashboard.weekly-review.name')"
							      width="120"
							      column-key="name"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="team"
							      :label="$t('dashboard.weekly-review.team')"
							      width="150"
							      sortable
							      :filters="teamFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getTeam(scope.row.team) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="practiceId"
							      :label="$t('dashboard.weekly-review.practice')"
							      width="150"
							      sortable
							      :filters="practiceFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getPractice(scope.row.practiceId) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="quota"
							      :label="$t('dashboard.weekly-review.quota')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.quota.toFixed(2) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="offer"
							      :label="$t('dashboard.weekly-review.offer')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="cashin"
							      :label="$t('dashboard.weekly-review.cashin')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="offerByNow"
							      :label="$t('dashboard.weekly-review.ocr')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.offerByNow.toFixed(2) }}%
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="cashinByNow"
							      :label="$t('dashboard.weekly-review.ccr')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.cashinByNow.toFixed(2) }}%
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="cftn"
							      :label="$t('dashboard.weekly-review.debt')"
							      width="120"
							      sortable>
							    </el-table-column>
							    
						    </el-table>
						</div>

						<div class="card-body">
							<h3>{{ $t('dashboard.weekly-review.finance') }}
								<el-tooltip :content="$t('salary.export')" placement="top">
									<el-button type="text" class="el-icon-download" @click="exportExcel('finance-report', 'Finance')"></el-button>
								</el-tooltip></h3>
							<el-table
							    id="finance-report"
							    :data="data.finance"
							    style="width: 100%"
							    height="500"
							    :default-sort = "{prop: 'team', order: 'ascending'}"
							    @cell-click="handleCellEvent"
							    :summary-method="getSummaries"
				    			:show-summary="false">
								<el-table-column
							      fixed
							      prop="name"
							      :label="$t('dashboard.weekly-review.name')"
							      width="120"
							      column-key="name"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="team"
							      :label="$t('dashboard.weekly-review.team')"
							      width="150"
							      sortable
							      :filters="teamFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getTeam(scope.row.team) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="practiceId"
							      :label="$t('dashboard.weekly-review.practice')"
							      width="150"
							      sortable
							      :filters="practiceFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getPractice(scope.row.practiceId) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="ar"
							      :label="$t('dashboard.weekly-review.ar')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.ar.toFixed(2) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="nio"
							      :label="$t('dashboard.weekly-review.nio')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="onboardNumber"
							      :label="$t('dashboard.weekly-review.onboard')"
							      width="120"
							      sortable>
							    </el-table-column>
						    </el-table>
						</div>

						<div class="card-body">
							<h3>{{ $t('dashboard.weekly-review.kpi') }}
								<el-tooltip :content="$t('salary.export')" placement="top">
									<el-button type="text" class="el-icon-download" @click="exportExcel('kpi-report', 'KPI')"></el-button>
								</el-tooltip></h3>
							<el-table
							    id="kpi-report"
							    :data="data.kpi"
							    style="width: 100%"
							    height="500"
							    :default-sort = "{prop: 'team', order: 'ascending'}"
							    @row-click="showKPIDetail"
							    :summary-method="getSummaries"
				    			:show-summary="false">
								<el-table-column
							      fixed
							      prop="name"
							      :label="$t('dashboard.weekly-review.name')"
							      width="120"
							      column-key="name"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="team"
							      :label="$t('dashboard.weekly-review.team')"
							      width="150"
							      sortable
							      :filters="teamFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getTeam(scope.row.team) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="practiceId"
							      :label="$t('dashboard.weekly-review.practice')"
							      width="150"
							      sortable
							      :filters="practiceFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getPractice(scope.row.practiceId) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="reported"
							      :label="$t('dashboard.weekly-review.report')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="cci"
							      :label="$t('dashboard.weekly-review.ccm')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="interview"
							      :label="$t('dashboard.weekly-review.inv')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="new_case"
							      :label="$t('dashboard.weekly-review.bd')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="cm"
							      :label="$t('dashboard.weekly-review.cm')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="bd"
							      :label="$t('dashboard.weekly-review.bd-call')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="new_cdd"
							      :label="$t('dashboard.weekly-review.new-cdd')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="cr"
							      :label="$t('dashboard.weekly-review.kpi-cr')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.cr.toFixed(2) }}%
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="kpi"
							      :label="$t('dashboard.weekly-review.ytd-kpi')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.kpi.toFixed(2) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="sc"
							      :label="$t('dashboard.weekly-review.sc')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.sc.toFixed(2) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="x"
							      :label="$t('dashboard.weekly-review.x')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.x.toFixed(2) }}
							      </template>
							    </el-table-column>
						    </el-table>
						</div>

						<div class="card-body">
							<h3>{{ $t('dashboard.weekly-review.case-review') }} 
								<el-tooltip :content="$t('salary.export')" placement="top">
									<el-button type="text" class="el-icon-download" @click="exportExcel('case-report', 'Case')"></el-button>
								</el-tooltip></h3>
							<el-table
							    id="case-report"
							    :data="data.case"
							    style="width: 100%"
							    height="500"
							    :default-sort = "{prop: 'team', order: 'ascending'}"
							    @cell-click="handleCellEvent"
							    :summary-method="getSummaries"
				    			:show-summary="false">
								<el-table-column
							      fixed
							      prop="name"
							      :label="$t('dashboard.weekly-review.name')"
							      width="120"
							      column-key="name"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="team"
							      :label="$t('dashboard.weekly-review.team')"
							      width="150"
							      sortable
							      :filters="teamFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getTeam(scope.row.team) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="practiceId"
							      :label="$t('dashboard.weekly-review.practice')"
							      width="150"
							      sortable
							      :filters="practiceFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getPractice(scope.row.practiceId) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="finalNumber"
							      :label="$t('dashboard.weekly-review.final')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="invNumber"
							      :label="$t('dashboard.weekly-review.interviewing')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="reportedNumber"
							      :label="$t('dashboard.weekly-review.recommended')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="zeroNumber"
							      :label="$t('dashboard.weekly-review.no-recommend')"
							      width="120"
							      sortable>
							    </el-table-column>
						    </el-table>
						</div>

						<div class="card-body">
							<h3>{{ $t('dashboard.weekly-review.efficiency') }}
								<el-tooltip :content="$t('salary.export')" placement="top">
									<el-button type="text" class="el-icon-download" @click="exportExcel('eff-report', 'Efficiency')"></el-button>
								</el-tooltip></h3>
							<el-table
							    id="eff-report"
							    :data="data.efficiency"
							    style="width: 100%"
							    height="500"
							    :default-sort = "{prop: 'team', order: 'ascending'}"
							    
							    :summary-method="getSummaries"
				    			:show-summary="false">
								<el-table-column
							      fixed
							      prop="name"
							      :label="$t('dashboard.weekly-review.name')"
							      width="120"
							      column-key="name"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="team"
							      :label="$t('dashboard.weekly-review.team')"
							      width="150"
							      sortable
							      :filters="teamFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getTeam(scope.row.team) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="practiceId"
							      :label="$t('dashboard.weekly-review.practice')"
							      width="150"
							      sortable
							      :filters="practiceFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getPractice(scope.row.practiceId) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="avgoAll"
							      :label="$t('dashboard.weekly-review.avgo')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.avgoAll.toFixed(2) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="avgo"
							      :label="$t('dashboard.weekly-review.avgo-me')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.avgo.toFixed(2) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="crAll"
							      :label="$t('dashboard.weekly-review.case-cr')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.crAll.toFixed(2) }}%
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="cr"
							      :label="$t('dashboard.weekly-review.case-cr-me')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.cr.toFixed(2) }}%
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="pipelineAll"
							      :label="$t('dashboard.weekly-review.pipeline')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.pipelineAll.toFixed(2) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="pipeline"
							      :label="$t('dashboard.weekly-review.pipeline-me')"
							      width="120"
							      sortable>							      
							    </el-table-column>
							    <el-table-column
							      prop="rtAll"
							      :label="$t('dashboard.weekly-review.report-time')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="rt"
							      :label="$t('dashboard.weekly-review.report-time-me')"
							      width="120"
							      sortable>							      
							    </el-table-column>
						    </el-table>
						</div>

						<div class="card-body">
							<h3>{{ $t('dashboard.weekly-review.cost') }} 
								<el-tooltip :content="$t('salary.export')" placement="top">
									<el-button type="text" class="el-icon-download" @click="exportExcel('cost-report', 'Cost')"></el-button>
								</el-tooltip></h3>
							<el-table
							    id="cost-report"
							    :data="data.cost"
							    style="width: 100%"
							    height="500"
							    :default-sort = "{prop: 'team', order: 'ascending'}"
							    :summary-method="getSummaries"
				    			:show-summary="false">
								<el-table-column
							      fixed
							      prop="name"
							      :label="$t('dashboard.weekly-review.name')"
							      width="120"
							      column-key="name"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="team"
							      :label="$t('dashboard.weekly-review.team')"
							      width="150"
							      sortable
							      :filters="teamFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getTeam(scope.row.team) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="practiceId"
							      :label="$t('dashboard.weekly-review.practice')"
							      width="150"
							      sortable
							      :filters="practiceFilter"
				                  :filter-method="filterHandler">
							      <template slot-scope="scope">
							        {{ getPractice(scope.row.practiceId) }}
							      </template>
							    </el-table-column>
							    <el-table-column
							      prop="salary"
							      :label="$t('dashboard.weekly-review.salary')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="sb"
							      :label="$t('dashboard.weekly-review.sb')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="exp"
							      :label="$t('dashboard.weekly-review.expense')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="bonus"
							      :label="$t('dashboard.weekly-review.bonus')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="tc"
							      :label="$t('dashboard.weekly-review.total')"
							      width="120"
							      sortable>
							    </el-table-column>
							    <el-table-column
							      prop="cr"
							      :label="$t('dashboard.weekly-review.cost-rate')"
							      width="120"
							      sortable>
							      <template slot-scope="scope">
							        {{ scope.row.cr.toFixed(2) }}%
							      </template>
							    </el-table-column>
						    </el-table>
						</div>
						
					</div>
				</div>
			</div>
		</div>

		<!--Modal -->
		<el-dialog :title="modalTitle" 
	      :visible.sync="showModal"
	      width="80%"
	      top="30px"
	      :append-to-body="true">
	            <Modal ref="modalDetail" :data="currentData" />
	            <div slot="footer" class="dialog-footer">
	          <el-button @click="showModal = false">{{ $t('dashboard.o-r.close') }}</el-button>
	      </div>
	    </el-dialog>
	</div>
</template>
<script>
// @ is an alias to /src
import Modal from '@/components/dashboard/Modal.vue'

import FileSaver from 'file-saver'
import XLSX from 'xlsx'
import moment from 'moment'
import { Loading } from 'element-ui'

export default {
  name: 'SalaryList',
  components: {
  	Modal
  },
  data: function() {
	return {
	  data: null,
	  dateRange: [moment().startOf('year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
	  currentData: null,
	  showModal: false,
	  currentTitle: null,
	  currentName: null
	}
  },
  watch: {
    dateRange: function(val) {
      this.refreshData()
    }
  },
  computed: {
    modalTitle: function() {
      if (this.currentTitle != null)
        return this.$t(this.currentTitle, { name: this.currentName })
      return ''
    },
    teamFilter: function() {
      let f = []
      for (let i = 0; i < this.team.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.team[i]['c_name'] : this.team[i]['e_name'],
        	value = this.team[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    },
    practiceFilter: function() {
      let f = []
      for (let i = 0; i < this.practice.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.practice[i]['c_name'] : this.practice[i]['e_name'],
        	value = this.practice[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    },
    legalEntityFilter: function() {
      let f = []
      for (let i = 0; i < this.legalEntity.length; i++) {
        let text = this.$i18n.locale === 'zh' ? this.legalEntity[i]['c_name'] : this.legalEntity[i]['e_name'],
          value = this.legalEntity[i].id
        f.push({
          'text': text,
          'value': value
        })
      }
      return f
    }
  },
  methods: {
    handleCellEvent: function(row, column, cell, event) {
      if (column.property == 'ar') {
        this.currentData = row.arDetail
        this.currentTitle = this.$t('dashboard.weekly-review.ar-detail') + row.name
        this.showModal = true
      } else if (column.property == 'onboardNumber') {
        //console.log(row.onboard)
        this.currentData = row.onboard
        this.currentTitle = this.$t('dashboard.weekly-review.onboard-detail') + row.name
        this.showModal = true
      } else if (column.property == 'finalNumber') {
        this.currentData = row.final
        this.currentTitle = this.$t('dashboard.weekly-review.final-detail') + row.name
        this.showModal = true
      } else if (column.property == 'invNumber') {
        this.currentData = row.inv
        this.currentTitle = this.$t('dashboard.weekly-review.inv-detail') + row.name
        this.showModal = true
      } else if (column.property == 'zeroNumber') {
        this.currentData = row.zero
        this.currentTitle = this.$t('dashboard.weekly-review.zero-detail') + row.name
        this.showModal = true
      } else if (column.property == 'reportedNumber') {
        this.currentData = row.reported
        this.currentTitle = this.$t('dashboard.weekly-review.reported-detail') + row.name
        this.showModal = true
      }
    },
    showKPIDetail: function(row, column, event) {
    	window.open(this.STARLINKS_URL + 'kpi/' + row.userId + '?duration=-1', '_blank')
    },
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    getSummaries: function(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('dashboard.o-r.sum')
          return
        }
        const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
            if (sums[index] != 0)
              sums[index] = sums[index].toFixed(2)
            else
              sums[index] = '';
          } else {
            sums[index] = ''
          }
        })
        return sums;
    },
    refreshData: function() {
      this.loadData()
    },
    exportExcel (id, name) {
	  let wb = XLSX.utils.table_to_book(document.querySelector('#' + id))
	  /* get binary string as output */
	  let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
	  try {
	    FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'ER-ReviewReport-' + name + '-' + this.dateRange[1] + '.xlsx')
	  } catch (e) {
	    if (typeof console !== 'undefined')
	      console.log(e, wbout)
	  }
	  return wbout
    },
    loadData: function() {
      let startDate = this.dateRange[0],
          endDate = this.dateRange[1],
          query = '?userId=' + localStorage.getItem('token') + '&startDate=' + startDate + '&endDate=' + endDate,
          that = this,
          loading = Loading.service({ fullscreen: true })

	  this.$http.get(this.API3_PREFIX + 'mreport' + query).then(function (response) {
		that.data = response.data
		that.$nextTick(() => {
          loading.close()
        })
      }).catch(function (error) {
		console.log(error)
		that.$nextTick(() => {
          loading.close()
        })
      })
    }
  },
  created: function() {
    this.loadData()
  }
}
</script>